import { render, staticRenderFns } from "./consentform.vue?vue&type=template&id=693c6ee8"
import script from "./consentform.vue?vue&type=script&lang=js"
export * from "./consentform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports